import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Teleport as _Teleport, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/delivery-zones.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-ff802cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "catalog" }
const _hoisted_2 = {
  key: 3,
  class: "catalog__settings settings"
}
const _hoisted_3 = { class: "settings__filters" }
const _hoisted_4 = { class: "catalog__tags-menu" }
const _hoisted_5 = { class: "catalog__content content" }
const _hoisted_6 = { class: "content__main-section" }
const _hoisted_7 = {
  key: 0,
  class: "content__banners"
}
const _hoisted_8 = { class: "content__search-bar" }
const _hoisted_9 = { class: "content__search-field" }
const _hoisted_10 = { class: "content__sort" }
const _hoisted_11 = { class: "content__product-list" }
const _hoisted_12 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_13 = { class: "content__order order" }
const _hoisted_14 = { class: "content__order--desktop" }
const _hoisted_15 = {
  key: 0,
  class: "order__delivery-zones delivery-zones"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "delivery-zones__image",
  src: _imports_0
}, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "content__order--mobile"
}
const _hoisted_18 = {
  key: 0,
  class: "content__pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RestaurantsDropDown = _resolveComponent("RestaurantsDropDown")!
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_KitchensList = _resolveComponent("KitchensList")!
  const _component_FiltersList = _resolveComponent("FiltersList")!
  const _component_ProductTagsMenu = _resolveComponent("ProductTagsMenu")!
  const _component_Cover = _resolveComponent("Cover")!
  const _component_Banners = _resolveComponent("Banners")!
  const _component_MoSearchField = _resolveComponent("MoSearchField")!
  const _component_SearchPanel = _resolveComponent("SearchPanel")!
  const _component_SortingPanel = _resolveComponent("SortingPanel")!
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_DesktopOrderPreviewLayout = _resolveComponent("DesktopOrderPreviewLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MobileOrderPreviewLayout = _resolveComponent("MobileOrderPreviewLayout")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#company-header-menu"
        }, [
          _createVNode(_component_MainMenu, {
            items: _ctx.menuItems,
            "is-mini-arrow": true,
            onSelectItem: _ctx.selectItem
          }, _createSlots({ _: 2 }, [
            (_ctx.companyStore.activeCompany?.restaurants.length)
              ? {
                  name: "left-col",
                  fn: _withCtx(() => [
                    (_ctx.companyStore.activeCompany.restaurants)
                      ? (_openBlock(), _createBlock(_component_RestaurantsDropDown, {
                          key: 0,
                          restaurants: _ctx.companyStore.activeCompany.restaurants,
                          "is-image-title": true,
                          "is-filters-open": _ctx.catalogStore.isMenuPanelOpened,
                          onSelect: _ctx.selectRestaurant
                        }, null, 8, ["restaurants", "is-filters-open", "onSelect"]))
                      : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["items", "onSelectItem"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#desktop-restaurants"
        }, [
          (_ctx.companyStore.activeCompany?.restaurants.length)
            ? (_openBlock(), _createBlock(_component_RestaurantsDropDown, {
                key: 0,
                class: "restaurants-drop-down--desktop",
                restaurants: _ctx.companyStore.activeCompany.restaurants,
                onSelect: _ctx.selectRestaurant
              }, null, 8, ["restaurants", "onSelect"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 2,
          to: "#mobile-restaurants"
        }, [
          (_ctx.companyStore.activeCompany?.restaurants.length)
            ? (_openBlock(), _createBlock(_component_RestaurantsDropDown, {
                key: 0,
                class: "restaurants-drop-down--mobile",
                "is-image-title": true,
                restaurants: _ctx.companyStore.activeCompany.restaurants,
                onSelect: _ctx.selectRestaurant
              }, null, 8, ["restaurants", "onSelect"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.catalogStore.isMenuPanelOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.currentFilter.isKitchen)
              ? (_openBlock(), _createBlock(_component_KitchensList, {
                  key: 0,
                  kitchens: _ctx.currentFilter.list,
                  "selected-ids": _ctx.currentFilter.selectedList,
                  onSelect: _ctx.currentFilter.select,
                  onClose: _ctx.closeFiltersPanel
                }, null, 8, ["kitchens", "selected-ids", "onSelect", "onClose"]))
              : (_openBlock(), _createBlock(_component_FiltersList, {
                  key: 1,
                  filters: _ctx.currentFilter.list,
                  "selected-ids": _ctx.currentFilter.selectedList,
                  onSelect: _ctx.currentFilter.select,
                  onClose: _ctx.closeFiltersPanel
                }, null, 8, ["filters", "selected-ids", "onSelect", "onClose"]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Cover, null, {
        default: _withCtx(() => [
          (_ctx.isOpenTagsMenu)
            ? (_openBlock(), _createBlock(_component_ProductTagsMenu, {
                key: 0,
                "selected-groups": _ctx.selectedProductGroups,
                "selected-groups-filters": _ctx.catalogStore.selectedGroupsIds,
                "selected-kinds": _ctx.selectedKinds,
                "selected-kitchens": _ctx.selectedKitchens,
                "is-open": _ctx.catalogStore.isMenuPanelOpened,
                "is-rolled": _ctx.catalogStore.isRolledTagMenu,
                onDeselect: _ctx.deselectTag,
                onReset: _ctx.resetTags,
                onToggle: _ctx.toggleActiveMenuItem,
                onSelectSubGroup: _ctx.selectSubGroups,
                onRoll: _cache[0] || (_cache[0] = ($event: any) => (_ctx.catalogStore.toggleRolledTagMenu(!_ctx.catalogStore.isRolledTagMenu)))
              }, null, 8, ["selected-groups", "selected-groups-filters", "selected-kinds", "selected-kitchens", "is-open", "is-rolled", "onDeselect", "onReset", "onToggle", "onSelectSubGroup"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.companyStore.activeCompany?.banners?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Banners, {
                items: _ctx.companyStore.activeCompany?.banners
              }, null, 8, ["items"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_MoSearchField, {
              "prop-search-value": _ctx.searchValue,
              onInput: _ctx.debouncedSearchProduct,
              onSearch: _ctx.searchProduct
            }, null, 8, ["prop-search-value", "onInput", "onSearch"]),
            (_ctx.isMounted)
              ? (_openBlock(), _createBlock(_Teleport, {
                  key: 0,
                  to: "#header-search"
                }, [
                  _createVNode(_component_SearchPanel, {
                    "search-value": _ctx.searchValue,
                    onInput: _ctx.debouncedSearchProduct,
                    onSearch: _ctx.searchProduct
                  }, null, 8, ["search-value", "onInput", "onSearch"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_SortingPanel, {
              items: _ctx.SORTS,
              "query-sort": _ctx.$route.query.sort,
              onSelect: _ctx.selectSorting
            }, null, 8, ["items", "query-sort", "onSelect"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.catalogStore.products.length)
            ? (_openBlock(), _createBlock(_component_ProductList, {
                key: 0,
                products: _ctx.catalogStore.products,
                onToggleFavorite: _ctx.toggleFavorite
              }, null, 8, ["products", "onToggleFavorite"]))
            : (
              _ctx.$route.query.name
                && !_ctx.catalogStore.isFirstLoad
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " По вашему запросу ничего не найдено "))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_DesktopOrderPreviewLayout),
          (_ctx.companyStore.activeCompany.hasDeliveryZone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  class: "profile-menu__link",
                  to: { name: 'c-delivery-zones' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "delivery-zones__title",
                  to: { name: 'c-delivery-zones' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Карта доставки ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.orderStore.totalItemsQuantity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_MobileOrderPreviewLayout)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.catalogStore.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_Pagination, {
              total: _ctx.catalogStore.totalProducts,
              "pages-count": _ctx.catalogStore.totalPages,
              "selected-page": _ctx.catalogStore.selectedPage,
              "page-size": _ctx.catalogStore.pageSize,
              onSelect: _ctx.selectPage
            }, null, 8, ["total", "pages-count", "selected-page", "page-size", "onSelect"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}